module.exports = __webpack_public_path__ + "898d41a991f8734a9da82c12047c69a7.png";